import Vue, { CreateElement } from 'src/vue'
import { Component } from 'vue-property-decorator'

import { Icon } from '@src/elements/icon/icon'
import { TimeSwitcher } from '@src/elements/time-switch/time-switch'
import ApiClient from '@src/lib/api_client'
import { getCurrentWeekPeriods } from '@src/util/functions'
import { API } from '@src/lib/api_path'
import { Body1, H5 } from '@src/elements/typography/typography'
import { Divider } from '@src/elements/divider/divider'
import { Chart } from '@src/components/chart/chart'
import { DateFilterType } from '@src/elements/time-switch/date-filter-type'

import './active-members.sass'

type ActiveMembersResponse = { periods: ActiveMembersPeriod[] }
type ActiveMembersPeriod = {
  from: string
  to: string
  active_members: number
  workouts: number
}

@Component
export class ActiveMembersStatistics extends Vue {

  private timeFrame: string = 'week'

  private activeMembers: number = 0
  private activeTrainings: number = 0

  private apiClient: ApiClient

  private activeMembersStats: ActiveMembersPeriod[] = []

  constructor () {
    super()
    this.apiClient = new ApiClient(API.TRAINERS_API.CLUB_STATS_ACTIVE_MEMBERS)
  }

  changeTimeFrame (timeFrame: string, periods: any[]) {
    return this.loadMemberStats(timeFrame, periods)
  }

  getChartSeries () {
    let members: any[] = []
    let workouts: any[] = []
    let totalWorkouts = 0
    let max = 0
    this.activeMembersStats.forEach(period => {
      members.push([new Date(period.from).getTime(), period.active_members])
      workouts.push([new Date(period.from).getTime(), period.workouts])
      totalWorkouts += period.workouts
      if (max < period.active_members) max = period.active_members
      if (max < period.workouts) max = period.workouts
    })
    this.activeTrainings = totalWorkouts

    return {
      max,
      series: [{
        data: members,
        name: this.$t('PAGE.CLUB.CLUB_STATISTICS.ACTIVE_MEMBERS'),
        color: '#4FACFE'
      },
      {
        data: workouts,
        name: this.$t('PAGE.CLUB.CLUB_STATISTICS.ACTIVE_TRAININGS'),
        color: '#79EDB6'
      }
      ]
    }
  }

  render (h: CreateElement) {
    const { series, max } = this.getChartSeries()
    return <div class='column active-members'>
      <TimeSwitcher dateFilters={[DateFilterType.WEEK, DateFilterType.MONTH, DateFilterType.YEAR]} change={this.changeTimeFrame} align='right' allowFutureDate={false} />

      <div id='activity-wrapper' class='row'>
        <div class='count'>
          <H5>{this.activeMembers}</H5>
          <Body1>{this.$t('PAGE.CLUB.CLUB_STATISTICS.ACTIVE_MEMBERS')}</Body1>
          <Icon name='brand/active-members' />
        </div>
        <div class='count'>
          <H5>{this.activeTrainings}</H5>
          <Body1>{this.$t('PAGE.CLUB.CLUB_STATISTICS.ACTIVE_TRAININGS')}</Body1>
          <Icon name='brand/active-trainings' />
        </div>
      </div>

      <div id='activeMembersChartWrapper'>

        <Chart chartId='activeMembersChart' series={series} maxOY={max}
               grid={{ padding: { left: 30, right: 30 } }}
               labelStyle={{ style: { color: '#212121', fontSize: '0.5rem' } }}
               emptyGraphMessage={this.$t('PAGE.CLUB.CLUB_STATISTICS.EMPTY_GRAPH_ACTIVE_MEMBERS')}
               dateType={this.timeFrame === DateFilterType.YEAR ? 'month' : 'day'}
        />
      </div>

      <Divider />
    </div>
  }

  beforeMount () {
    return this.loadMemberStats(this.timeFrame, getCurrentWeekPeriods())
  }

  private loadMemberStats (timeFrame: string, periods: any[]) {
    const allPeriod = { from: periods[0].from, to: periods[periods.length - 1].to }
    this.apiClient.get<ActiveMembersResponse>('', { periods: [allPeriod] })
      .then((response) => this.activeMembers = response.periods[0].active_members)
      .catch((error) => console.error('failed to retrieve club stats - active members Counter', error))

    return this.apiClient.get<ActiveMembersResponse>('', { periods: periods })
      .then((response) => {
        this.timeFrame = timeFrame
        this.activeMembersStats = response.periods
      })
      .catch((error) => console.error('failed to retrieve club stats - active members', error))
  }
}
